import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RefreshCw } from "lucide-react";
import { Botao } from "@/components/sistema";
import { EVENTO_ATUALIZACAO } from "@/lib/atualizacao";

/**
 * O aviso de versão nova, quando ela chega com o app em uso.
 *
 * Um cartão fixo acima da navbar, com texto de leitura (--t-corpo) e o botão
 * de atualizar no piso da régua. Substitui o toast de 13px, que este público
 * não lia — e, quando lia, não achava o botão de 12px.
 */
const AvisoAtualizacao = () => {
  const { t } = useTranslation();
  const [worker, setWorker] = useState<ServiceWorker | null>(null);

  useEffect(() => {
    const ouvir = (e: Event) => setWorker((e as CustomEvent<ServiceWorker>).detail);
    window.addEventListener(EVENTO_ATUALIZACAO, ouvir);
    return () => window.removeEventListener(EVENTO_ATUALIZACAO, ouvir);
  }, []);

  if (!worker) return null;

  return (
    <div
      className="fixed left-0 right-0 z-[60] safe-bottom"
      style={{ bottom: "calc(var(--nav-baixo) + 8px)", padding: "0 var(--gutter)" }}
    >
      <div className="cartao mx-auto max-w-[480px]" style={{ padding: 18, boxShadow: "0 12px 32px rgba(0,0,0,0.35), inset 0 0 0 1px hsl(var(--border))" }}>
        <p className="font-bold leading-tight" style={{ fontSize: "var(--t-linha)" }}>
          {t("pwa.update_available", "Update available")}
        </p>
        <p className="pt-1 leading-snug" style={{ fontSize: "var(--t-corpo)", color: "var(--tinta-apoio)" }}>
          {t("pwa.update_hint", "A new version of the app is ready.")}
        </p>
        <div style={{ paddingTop: 14, display: "grid", gap: 10 }}>
          <Botao
            rotulo={t("pwa.update_now", "Update now")}
            icone={RefreshCw}
            onClick={() => worker.postMessage({ type: "SKIP_WAITING" })}
          />
          <Botao rotulo={t("pwa.update_later", "Later")} variante="secundaria" onClick={() => setWorker(null)} />
        </div>
      </div>
    </div>
  );
};

export default AvisoAtualizacao;
